import { Block } from '@/components/crRender'
import { translate } from '@/utils/langUtils'
import React from 'react'
import './style.css'
import { IsListNotEmpty } from '@/utils/varsManipulations'
const BillList = ({ List  ,title="" }) => {
    return (

        <Block isRender={IsListNotEmpty(List)} className="qd-summary-list-container" >
            <Block isRender={!!title}    className="qd-summary-item qd-summary-title-item" >{translate(title) } <span className="qd-summary-value">${List?.reduce((sum, ps) => sum + ps.price, 0)}</span></Block>
            <ul className="qd-summary-list">
                {List?.map((ps) => (
                    <li className="qd-summary-list-item" key={ps.id}>
                        <div className="border-delemeter" />
                        <span className="qd-summary-value-label">{ps.name}</span>
                        <span className="qd-summary-value">${ps.price}.00</span>
                    </li>
                ))}
            </ul>
        </Block>)
}

export default BillList